export * from "../global/social-whatsapp";
